export default __webpack_public_path__ + "static/media/chevron.af6323b0.svg";